import { authAndUsersApi } from "./api/authAndUsers.js";
import { crmApi } from "./api/crm.js";
import { catalogApi, salesApi } from "./api/catalogAndSales.js";
import { jobsApi } from "./api/jobs.js";
import { shopFloorApi } from "./api/shopFloor.js";
import { inventoryApi } from "./api/inventory.js";
import { purchasingApi } from "./api/purchasing.js";
import { financeApi } from "./api/finance.js";
import { reportingApi } from "./api/reporting.js";
import { importsApi } from "./api/imports.js";

export const api = {
  ...authAndUsersApi,
  ...crmApi,
  ...catalogApi,
  ...salesApi,
  ...jobsApi,
  ...shopFloorApi,
  ...inventoryApi,
  ...purchasingApi,
  ...financeApi,
  ...reportingApi,
  ...importsApi,
};

export { attachmentContentUrl } from "./api/authAndUsers.js";
export { quotePdfUrl, jobPdfUrl } from "./api/catalogAndSales.js";
